angular.module("ainapp")
    .factory("viewCounterSalesFactory", ["$uibModal",
        function ($uibModal) {
            return {
                select: function (cid) {
                    var modalInstance = $uibModal.open({
                        templateUrl: "Templates/viewCounterSalesModal.tpl.html",
                        windowClass: "modal-view fade",
                        animation: true,
                        backdrop: true,
                        controller: ['$http', '$scope', "app.config", "MainService", "AuthenticationService", "LanguageService",
                            function ($http, $scope, config, MainService, AuthenticationService, LanguageService) {
                                ($scope.init = function () {
                                    $scope.filter = {
                                        Keyword: null,
                                        cid: cid
                                    };


                                    $scope.Language = "EN";
                                    $scope.Direction = "ltr";
                                    var lan = AuthenticationService.getlanInfo();
                                    if (lan != null) {
                                        $scope.Language = lan;
                                        if ($scope.Language == "AR") {
                                            $scope.Direction = "rtl";
                                        }
                                    }
                                    $scope.LanguageData = LanguageService.getLanguageData($scope.Language);



                                    $scope.SalesSource = new kendo.data.DataSource({
                                        transport: {
                                            read: function (o) {
                                                o.data.CounterId = cid;
                                                MainService.CounterSalesInView(o.data).then(function (response) {
                                                    o.success(response.data);
                                                }, function (err) {
                                                    o.success(false);
                                                    toastr.error($scope.NetworkErrorLan);
                                                })
                                            }
                                        },
                                        change: function (data) {},
                                        schema: {
                                            data: "Data",
                                            total: "Total",
                                            model: {
                                                id: "Id",
                                                fields: {
                                                    Date: {
                                                        type: "date",
                                                    },
                                                    BillNo: {
                                                        type: "string",
                                                    },
                                                    PayType: {
                                                        type: "string",
                                                    },

                                                    "AccountMaster.Name": {
                                                        type: "string",
                                                    },
                                                    "User.UserName": {
                                                        type: "string",
                                                    },

                                                    SubTotal: {
                                                        type: "number",
                                                    },
                                                    Taxable: {
                                                        type: "number",
                                                    },
                                                    TotalQuantity: {
                                                        type: "number",
                                                    },
                                                    TotalDiscount: {
                                                        type: "number",
                                                    },
                                                    TotalVAT: {
                                                        type: "number",
                                                    },
                                                    GrandTotal: {
                                                        type: "number",
                                                    },
                                                    IsPaymentDone: {
                                                        type: "boolean",
                                                    },

                                                }
                                            }
                                        },
                                        pageSize: 10,
                                        serverPaging: true,
                                        serverSorting: true,
                                        serverFiltering: true,
                                    });

                                    $scope.SalesFactory = {
                                        stretch: true,
                                        selectable: true,
                                        groupable: true,
                                        height: 550,
                                        sortable: true,
                                        resizable: true,
                                        dataSource: $scope.SalesSource,
                                        pageable: true,
                                        dataBound: onDataBound,
                                        filterable: true,

                                        columns: [
                                            {
                                                field: "BillNo",
                                                title: "#",
                                            },
                                            {
                                                field: "AccountMaster.Name",
                                                title: "Customer",
                                            },

                                            {
                                                field: "Date",
                                                template: "<p> {{dataItem.Date | date: 'dd/MM/yyyy'}}<p/>",
                                                title: "Date",
                                            },
                                            {
                                                field: "PayType",
                                                title: "Pay Type",
                                            },
                                            {
                                                field: "SubTotal",
                                                title: "Sub Total",
                                                template: "<div style='text-align: right'>#=kendo.toString(SubTotal, 'n')#</div>",

                                            },
                                            {
                                                field: "TotalDiscount",
                                                title: "Total Discount",
                                                template: "<div style='text-align: right'>#=kendo.toString(TotalDiscount, 'n')#</div>",

                                            },
                                            {
                                                field: "Taxable",
                                                title: "Taxable",
                                                template: "<div style='text-align: right'>#=kendo.toString(Taxable, 'n')#</div>",

                                            },
                                            {
                                                field: "TotalVAT",
                                                title: "Total VAT",
                                                template: "<div style='text-align: right'>#=kendo.toString(TotalVAT, 'n')#</div>",

                                            },
                                            {
                                                field: "GrandTotal",
                                                title: "Grand Total",
                                                template: "<div style='text-align: right'>#=kendo.toString(GrandTotal, 'n')#</div>",

                                            },
                                            {
                                                field: "TotalQuantity",
                                                title: "Total Qty",
                                                template: "<div style='text-align: right'>#=kendo.toString(TotalQuantity, 'n')#</div>",

                                            },
                                            {
                                                field: "IsPaymentDone",
                                                title: "Payment Done?",
                                                template: "<p ng-if='dataItem.IsPaymentDone'>Yes</p> <p ng-if='!dataItem.IsPaymentDone'>No</p>"
                                            },

                                        ],
                                    };
                                })()

                                function onDataBound() {
                                    var grid = this;
                                    grid.element.on('dblclick', 'tbody tr[data-uid]', function (e) {
                                        $scope.confirm();
                                    })
                                }

                                /**  kendo  **/
                                $scope.confirmText = "Confirm";
                                $scope.cancelText = "Cancel";

                                $scope.cancel = function () {
                                    modalInstance.dismiss('cancel');
                                };
                                $scope.confirm = function () {
                                    grid = $("#Sales-grid").data("kendoGrid");
                                    var selectedData = grid.dataItem(grid.select());
                                    modalInstance.close(selectedData);
                                };
                                $scope.search = function () {
                                    $("#Sales-grid").data("kendoGrid").dataSource.read();
                                };
                                $scope.reset = function () {
                                    $scope.filter = {
                                        Keyword: null
                                    };
                                    $("#Sales-grid").data("kendoGrid").dataSource.read();
                                };
                            }
                        ]
                    });
                    return modalInstance.result;
                }
            }
        }
    ])
